import { render } from "./Settings.vue?vue&type=template&id=30c596c5"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=30c596c5&lang=scss"
script.render = render

export default script